<script>
import {AppConfig} from "@/AppConfig";

export default {
  name: "HomePage",
  mounted() {
    console.log("HomePage mounted")
    let accountType = this.$store.state.accountType
    if (accountType === "manage") {
      this.manageJump()
    } else if (accountType === "employee") {
      this.employeeJump()
    }
  },
  methods: {
    manageJump() {
      let loginInfo = this.$store.state.loginInfo
      console.log("manageJump", loginInfo.roleType)
      if (loginInfo.roleType === "GUARD") {
        this.$router.push({path: "/guard"})
      } else {
        this.$router.push({name: "subscribe"}) // page 页面内部会再次重定向
      }
    },

    employeeJump() {
      let loginInfo = this.$store.state.employeeLoginInfo
      let checkInvitePermission = AppConfig.checkInvitePermission
      console.log("employeeJump", loginInfo.name, loginInfo.inviteAuth, checkInvitePermission,)
      if (checkInvitePermission && loginInfo.inviteAuth !== "VALID") {
        this.$router.push({name: 'appliedRecord'})
      } else {
        this.$router.push({name: 'inviteVisitor'})
      }
    },
  }
}
</script>

<template>
  <div>
  </div>
</template>

<style scoped lang="less">

</style>
